import { useEffect, useState } from 'react'
import Slides from '../slides/Slides'
import { Link } from 'react-router-dom';
import { useAuthContext } from '../../context/authContext';
import Swal from 'sweetalert2';
import { WebService } from '../../services/webService';

const Cursos = ({M}) => {
   const [cursos,setCursos] = useState();
   const { logout, nominaID } = useAuthContext();
   const handleLogout = (e) => {
      logout();
   };
   const getCursos = async () => {
      try {
         const data = await WebService.getCursos(nominaID);
         setCursos(data || []);
      } catch (error) {
         Swal.fire({
            icon: "error",
            title: "Error!",
            text: "No se pudieron cargar los cursos",
            confirmButtonColor: "#147B9C",
         });
      }
   };
   const handleRealizado = (e) => {
      Swal.fire({
         icon: 'warning',
         title: '¡Atención!',
         text: 'Ud. Ya realizo la capacitación',
         showConfirmButton: true,
         confirmButtonText: "Ok",
      });
   }
   useEffect(() => {
      getCursos();
   }, []);
   return (
      <>
         <Slides M={M} tipoSlides={"capacitacion"}/>
         <div className="section animated fadeIn">
            <div className="row center">
               <div className="container center">
                  <div className="row">
                     <div className="col s12 m12">
                        <div className="alert alert-success">
                           ¡Mirá los videos, respondé el cuestionario y obtené el <strong>certificado</strong> para acreditar que participaste en la Capacitación!
                        </div>
                     </div>
                  </div>
                  <div className="row">
                     <div className="col s12 m12 center-align">
                        <Link className="btn waves-effect waves-light red accent-3" onClick={()=>handleLogout()}>Salir
                           <i className="material-icons right">send</i>
                        </Link>
                     </div>
                  </div>
                  <div className="row">
                  {cursos?.map((c,index) => {
                     return(
                        <div key={index} className="col s12 m6">
                           <div className="card blue-grey darken-1">
                              <div className="card-content white-text">
                                 <span className="card-title">{c.curso_titulo}</span>
                                 <p>{c.curso_descripcion}</p>
                              </div>
                              <div className="card-action">
                                 <Link to={`videos/${c.curso_id}`}>Videos</Link>
                                 {c.status ?
                                    <Link onClick={()=>handleRealizado()}>Cuestionario</Link>
                                    :
                                    <Link to={`cuestionario/${c.curso_id}`}>Cuestionario</Link>
                                 }
                              </div>
                           </div>
                        </div>
                     )
                  })}
                  </div>
               </div>
            </div>
         </div>
      </>
   )
}

export default Cursos